import { defineKey as T } from '@ha/intl';
import { FeaturedCountries } from 'ha/constants/FeaturedCountries';

export const showRegistration = (countryCode: string) => {
  const isFeaturedCountry = FeaturedCountries.some(
    country => country.code === countryCode,
  );

  // featured cities without registration
  const countriesWithoutRegistration = ['fr', 'cz', 'ie', 'pl', 'hu', 'gr'];

  return (
    isFeaturedCountry && !countriesWithoutRegistration.includes(countryCode)
  );
};

const RegistrationLocalTranslation: Record<string, string> = {
  at: T('registration_austria'),
  be: T('registration_belgium'),
  ch: T('registration_switzerland'),
  de: T('registration_germany'),
  is: T('registration_iceland'),
  it: T('registration_italy'),
  nl: T('registration_netherlands'),
  pt: T('registration_portugal'),
  es: T('registration_spain'),
};

export const getLocalRegistrationTranslationByCountry = (
  countryCode: string,
): string => RegistrationLocalTranslation[countryCode] || '';

const RegistrationDescriptionLocalTranslation: Record<string, string> = {
  at: T('tenant.registration_info.austria'),
  be: T('tenant.registration_info.belgium'),
  ch: T('tenant.registration_info.switzerland'),
  de: T('tenant.registration_info.germany'),
  is: T('tenant.registration_info.iceland'),
  it: T('tenant.registration_info.italy'),
  nl: T('tenant.registration_info.netherlands'),
  pt: T('tenant.registration_info.portugal'),
  es: T('tenant.registration_info.spain'),
};

export const getLocalRegistrationDescriptionTranslationByCountry = (
  countryCode: string,
): string => RegistrationDescriptionLocalTranslation[countryCode] || '';
